import * as React from 'react';

// eslint-disable-next-line @gandi/gandi/no-private-import

import { Form as FinalForm } from 'react-final-form';
import { Form as CsrfForm } from '../../components/Form';
import { FormProvider } from './FormProvider';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Syntaxic sugar with all-in-one form
 *
 * XXX: Generic type is not super useful in jsx. For now it provides better type than any in FormProps.
 */
export function Form({
  children,
  className,
  csrf,
  id,
  ...finalFormProps
}) {
  return (
    /*#__PURE__*/
    // $FlowFixMe[prop-missing] FinalForm's FormProps definition isn't compatible with exact_by_default
    _jsx(FormProvider, {
      ...finalFormProps,
      children: ({
        handleSubmit
      }) => /*#__PURE__*/_jsx(CsrfForm, {
        className: className,
        csrf: csrf,
        id: id,
        noValidate: false,
        onSubmit: handleSubmit,
        children: children
      })
    })
  );
}